import { cn } from '@/lib/utils';
import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackInitiateCheckout } from '../utils/metaPixel';
interface CTAButtonProps {
  label?: string;
  className?: string;
  href?: string;
  variant?: 'green' | 'dark' | 'light';
  showArrow?: boolean;
}

/** Checkout oficial y único de 100 Scripts de WhatsApp. */
export const CHECKOUT_URL = 'https://100-scripts-de-whatsapp-para-cerrar-mas-ventas.impultienda.ar/checkout';
export function CTAButton({
  label = 'QUIERO LOS 100 SCRIPTS',
  className = '',
  href = CHECKOUT_URL,
  variant = 'green',
  showArrow = true
}: CTAButtonProps) {
  const goesToCheckout = href.startsWith(CHECKOUT_URL);
  const handleClick = () => {
    if (goesToCheckout) trackInitiateCheckout();
  };
  const palette = variant === 'dark' ? 'bg-ink text-white hover:bg-graphite-soft focus-visible:ring-ink/40' : variant === 'light' ? 'bg-white text-ink hover:bg-mist focus-visible:ring-white/50' : 'bg-wa text-ink shadow-[0_14px_30px_-10px_rgba(11,107,52,0.55)] hover:bg-[#1FBE5B] hover:shadow-[0_18px_38px_-12px_rgba(11,107,52,0.6)] focus-visible:ring-wa/50';
  return <a href={href} onClick={handleClick} className={cn('group inline-flex min-h-[58px] items-center justify-center gap-2.5 rounded-xl px-7 py-4 text-center font-display text-[0.95rem] font-bold uppercase leading-tight tracking-[0.03em] transition-[transform,box-shadow,background-color] duration-200 ease-out hover:-translate-y-0.5 focus:outline-none focus-visible:ring-4', palette, className)} data-id="element-49" data-mp="1dcba0qnilaup">
      {label}
      {showArrow && <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden strokeWidth={2.5} data-id="element-50" data-mp="2125kx2o9wpcb" />}
    </a>;
}